import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';
import { ApartmentDTO, EntrancePlantDetailDTO, GateDTO } from 'client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'GateAccessSection',
  components: {},
  props: {    
    apartmentSelected: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
    editingApartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['gate-access-edited', 'error-gate-access'],
  watch: {
    "apartmentGates.length": function () {
      this.gateWasEdited();
    }
  },
})

export default class GateAccessSection extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  editingApartment!: ApartmentDTO;
  apartmentSelected!: ApartmentDTO;

  readonly applyToAllTheResidents = 'all_residents';
  apartmentGates: string[] = []


  get gates() {
    return this.currentEntrancePlant.gates ?? [];
  }

  get retrieveApartmentGates() {
    return this.gates.filter(g => g.apartments!.includes(this.apartmentSelected.apartmentId!)) ?? [];
  }

  get currentEntrancePlantGatesCount() {
    return this.currentEntrancePlant.gates?.length ?? 0;
  }

  mounted(): void {
    this.apartmentGates = this.retrieveApartmentGates.map(gate => gate.gateId!);
  }

  gateAccessEdited() {
    const edited = this.apartmentGates.length !== this.retrieveApartmentGates.length || 
      this.apartmentGates.some(g => !this.retrieveApartmentGates.map(gate => gate.gateId!).includes(g));
    return edited;
  }

  gateWasEdited() {
    this.$emit('gate-access-edited', this.gateAccessEdited(), this.apartmentGates);
  }

}
